// removed by extract-text-webpack-plugin
module.exports = {"root":"main__root"};


//////////////////
// WEBPACK FOOTER
// ./src/show-index/containers/main/styles.less
// module id = 482
// module chunks = 3